if (!customElements.get('rs7gt-launch-clock')) {
  customElements.define('rs7gt-launch-clock', class extends HTMLElement {
    connectedCallback() {
      this.description = this.querySelector('[data-scroll-clock-accessible]');
      this.fields = ['hours', 'minutes', 'seconds'].map(unit =>
        this.querySelector(`[data-scroll-clock-${unit}]`)
      );
      this.formatters = ['hour', 'minute', 'second'].map(unit =>
        new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
          style: 'unit', unit, unitDisplay: 'long'
        })
      );
      this.seconds = null;
      this.renderTime(0);
      this.closest('rs7gt-launch')?.requestScroll?.();
    }

    updateProgress(y, stops = []) {
      if (!this.isConnected || !this.fields) return;
      let step = 0;
      // Follow the actual scroll position, including every intermediate frame
      // of a chapter transition. One interval represents one minute.
      for (let index = 1; index < stops.length; index += 1) {
        const previous = stops[index - 1].y;
        const next = stops[index].y;
        if (y >= next) step = index;
        else {
          step = index - 1 + Math.max(0, (y - previous) / (next - previous));
          break;
        }
      }
      // Rounding also absorbs the browser's subpixel rounding at page stops.
      this.renderTime(Math.min(359999, Math.round(step * 60)));
    }

    renderTime(seconds) {
      if (seconds === this.seconds) return;
      this.seconds = seconds;
      const values = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60];
      values.forEach((value, index) => {
        const digits = String(value).padStart(2, '0');
        Array.from(this.fields[index].children).forEach((span, position) => {
          if (span.textContent !== digits[position]) span.textContent = digits[position];
        });
      });
      this.description.textContent = values.map((value, index) => this.formatters[index].format(value)).join(', ');
    }
  });
}
